import { closeAll as closeAllDialogs } from '@/components/Dialogs/DialogUtils';
import AlarmMsg from '@/utils/alarmMsg';

const beforeHook = (to, from, next) => {
	if (to.path !== from.path && !to.params?.isDialogOpen && !from.params?.isDialogOpen) {
		closeAllDialogs();
	}

	if (to.path.includes('pinIssuance')) {
		next('/home')
		AlarmMsg.showMsg('핀발행 서비스는 모바일 환경에서 지원되지<br/> 않습니다. PC에서 확인해 주세요.')
	}

	next();
};

export default beforeHook;
